import { TIMEZONE_VN } from 'constant';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

// eslint-disable-next-line import/prefer-default-export
export const formatDatetime = (date, template, tz = TIMEZONE_VN) => {
  if (!date || !dayjs(date).isValid()) return '';

  return dayjs(date).tz(tz).format(template);
};
